import React from 'react';
import wrapStore from '@src/utils/wrap-store';
import DisplayPublicFooter from '../display-public-footer';
import PageStore from '@src/components/page/store';
import { noop } from '@src/utils/common-util';
import rootStore from '@src/mobx-store/root-store';
const { globalStore } = rootStore;
/**
 * 页面包裹
 * @param children
 * @param rest
 * @returns {JSX.Element}
 * @constructor
 */
const Page = ({ children, store, scrollThreshold = 100, isListenPageScrollCeillingNavBar = true, getScrollingContainer = noop, _ref, ...rest }) => {
  store.use();

  React.useEffect(() => {
    // 页面向下滚动一定距离时顶栏吸顶
    if (isListenPageScrollCeillingNavBar) {
      const scrollingContainer = getScrollingContainer();
      if (scrollingContainer) {
        const listener = e => {
          globalStore.toggleNavBarStickState(e.target.scrollTop > scrollThreshold);
        };
        scrollingContainer.addEventListener('scroll', listener);
        return () => {
          scrollingContainer.removeEventListener('scroll', listener);
        };
      } else {
        const listener = e => {
          const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
          globalStore.toggleNavBarStickState(scrollTop > scrollThreshold);
        };
        window.addEventListener('scroll', listener);
        return () => {
          window.removeEventListener('scroll', listener);
        };
      }
    }
  }, []);

  return (
    <div ref={_ref} {...rest}>
      {children}
      <DisplayPublicFooter />
    </div>
  );
};

export default wrapStore(Page, PageStore);
